(function () {
  if (window.NocteLanding) return;
  var clamp = function (v, a, b) { a = a == null ? 0 : a; b = b == null ? 1 : b; return Math.min(b, Math.max(a, v)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ease = 'cubic-bezier(.22,1,.36,1)';
  var io = null, cio = null;
  var INIT = { up: 'translate3d(0,32px,0)', fade: 'none', scale: 'scale(.96)', left: 'translate3d(-40px,0,0)', right: 'translate3d(40px,0,0)', mask: 'translate3d(0,125%,0)' };
  var money = function (cents) { try { return '$' + Math.round(cents / 100).toLocaleString('es-CL'); } catch (e) { return '$' + Math.round(cents / 100); } };

  if (!reduced && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        show(e.target._rv || e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.5 });
  }

  function show(el) {
    if (el.dataset.shown) return; el.dataset.shown = '1';
    var d = +el.dataset.delay || 0, dur = el.dataset.reveal === 'mask' ? 1000 : 900;
    el.style.transition = 'opacity ' + dur + 'ms ' + ease + ' ' + d + 'ms, transform ' + dur + 'ms ' + ease + ' ' + d + 'ms';
    el.style.opacity = '1'; el.style.transform = 'none';
  }
  function sweep() {
    var vh = window.innerHeight;
    document.querySelectorAll('[data-rv]:not([data-shown])').forEach(function (el) {
      var r = (el._tg || el).getBoundingClientRect();
      if (r.top < vh * 0.97 && r.bottom > 0) show(el);
    });
  }

  function countUp(el) {
    var t = +el.dataset.count, t0 = performance.now(), dur = 1500;
    var f = function (now) { var p = clamp((now - t0) / dur); el.textContent = Math.round(t * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(f); };
    requestAnimationFrame(f);
  }

  function scan(root) {
    if (!io) return;
    root.querySelectorAll('[data-reveal]:not([data-rv])').forEach(function (el) {
      el.setAttribute('data-rv', '1');
      var t = el.dataset.reveal;
      if (t !== 'mask') el.style.opacity = '0';
      el.style.transform = INIT[t] || 'none';
      var target = (t === 'mask' && el.parentElement) ? el.parentElement : el;
      target._rv = el; el._tg = target;
      io.observe(target);
    });
    root.querySelectorAll('[data-count]:not([data-cv])').forEach(function (el) {
      el.setAttribute('data-cv', '1'); if (+el.dataset.count > 0) cio.observe(el);
    });
  }

  function progress(el) { var r = el.getBoundingClientRect(); return clamp(-r.top / Math.max(1, r.height - window.innerHeight)); }

  function pin() {
    document.querySelectorAll('[data-n-how],[data-n-why]').forEach(function (sec) {
      var inner = sec.firstElementChild; if (!inner) return;
      var r = sec.getBoundingClientRect(), ir = inner.getBoundingClientRect();
      var cur = +inner.dataset.ty || 0;
      var natural = ir.top - r.top - cur;
      var want = clamp(-r.top, 0, Math.max(0, r.height - inner.offsetHeight));
      var need = want - natural; if (Math.abs(need) < 1) need = 0;
      if (need !== cur) { inner.style.transform = need ? 'translate3d(0,' + need + 'px,0)' : ''; inner.dataset.ty = need; }
    });
  }

  function tick() {
    var mc = document.getElementById('MainContent'); var vh = window.innerHeight;
    var y = Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, document.body.scrollTop || 0, mc ? -mc.getBoundingClientRect().top : 0);
    pin(); sweep();
    if (!reduced) {
      document.querySelectorAll('[data-n-parallax]').forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        el.style.transform = 'translate3d(0,' + clamp(-r.top + vh * 0.05, 0, vh) * 0.1 + 'px,0)';
      });
      document.querySelectorAll('[data-n-zoom]').forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect(); var p = clamp((vh - r.top) / (vh + r.height));
        el.style.transform = 'scale(' + (1.16 - p * 0.16) + ')';
      });
    }
    document.querySelectorAll('[data-n-why]').forEach(function (sec) {
      var wp = progress(sec), track = sec.querySelector('[data-n-why-track]'), bars = sec.querySelectorAll('[data-n-why-bar]');
      if (track) { var dist = Math.max(0, track.scrollWidth - window.innerWidth); track.style.transform = 'translate3d(' + (-wp * dist) + 'px,0,0)'; }
      var n = bars.length, st = Math.min(n - 1, Math.floor(wp * (n + 0.2)));
      bars.forEach(function (b, i) { b.style.transform = 'scaleX(' + (i <= st ? 1 : 0) + ')'; });
    });
    document.querySelectorAll('[data-n-how]').forEach(function (sec) {
      var steps = sec.querySelectorAll('[data-n-step]'), n = steps.length || 1;
      var st = Math.min(n - 1, Math.floor(progress(sec) * n));
      if (sec._st === st) return; sec._st = st;
      var mobile = window.innerWidth < 820;
      steps.forEach(function (li, i) {
        li.style.opacity = i === st ? 1 : (mobile ? 0.4 : 0.35);
        var g = li.querySelector('[data-n-step-body]'); if (g) g.style.gridTemplateRows = i === st ? '1fr' : '0fr';
      });
      var f = st / Math.max(1, n - 1);
      var set = function (sel, on, off) { var el = sec.querySelector(sel); if (!el) return; el.style.opacity = on ? 1 : 0; if (off) el.style.transform = on ? 'none' : off; };
      set('[data-n-skin]', st === 0);
      set('[data-n-patch]', f >= 0.33, 'translateY(-24px) scale(1.06)');
      set('[data-n-zone]', f >= 0.66, 'scale(.9)');
      set('[data-n-zone-label]', f >= 0.66);
      set('[data-n-result]', st === n - 1 && n > 1, 'translateY(16px)');
      sec.querySelectorAll('[data-n-step-img]').forEach(function (im) { im.style.opacity = (+im.dataset.nStepImg === st) ? 1 : 0; });
      var lab = sec.querySelector('[data-n-step-label]'); if (lab) lab.textContent = '0' + (st + 1) + ' / ' + (n < 10 ? '0' : '') + n;
      var bar = sec.querySelector('[data-n-how-bar]'); if (bar) bar.style.transform = 'scaleX(' + ((st + 1) / n) + ')';
    });
    document.querySelectorAll('[data-n-sticky-cta]').forEach(function (el) {
      var on = y > vh * 0.85; el.classList.toggle('is-on', on); el.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
  }
  var raf = null;
  var onScroll = function () { pin(); if (raf) return; raf = requestAnimationFrame(function () { raf = null; tick(); }); };
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('load', tick);
  setInterval(function () { if (document.querySelector('[data-n-how],[data-n-why]')) tick(); }, 400);
  window.addEventListener('resize', function () { document.querySelectorAll('[data-n-how]').forEach(function (s) { s._st = -1; }); tick(); });

  function initAreas(root) {
    root.querySelectorAll('[data-n-areas]:not([data-ok])').forEach(function (sec) {
      sec.setAttribute('data-ok', '1');
      var tabs = sec.querySelectorAll('[data-n-tab]'), imgs = sec.querySelectorAll('[data-n-area-img]'), txts = sec.querySelectorAll('[data-n-area-txt]'), shape = sec.querySelector('[data-n-shape]');
      function sel(i) {
        tabs.forEach(function (t, k) { var on = k === i; t.setAttribute('aria-selected', on); t.style.background = on ? 'var(--n-ink)' : 'transparent'; t.style.color = on ? 'var(--n-bg)' : 'var(--n-ink)'; });
        imgs.forEach(function (el, k) { var on = k === i; el.style.opacity = on ? 1 : 0; el.style.zIndex = on ? 2 : 1; el.style.transform = on ? 'scale(1)' : 'scale(1.05)'; });
        txts.forEach(function (el, k) { var on = k === i; el.style.opacity = on ? 1 : 0; el.style.visibility = on ? 'visible' : 'hidden'; el.style.pointerEvents = on ? 'auto' : 'none'; el.style.transform = on ? 'none' : (k < i ? 'translateX(-24px)' : 'translateX(24px)'); el.setAttribute('aria-hidden', on ? 'false' : 'true'); });
        var t = tabs[i]; if (shape && t) { shape.style.width = t.dataset.w; shape.style.height = t.dataset.h; shape.style.borderRadius = t.dataset.r; shape.style.transform = t.dataset.tf; }
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { sel(i); }); });
      if (tabs.length) sel(0);
    });
  }

  function initBA(root) {
    root.querySelectorAll('[data-n-ba]:not([data-ok])').forEach(function (box) {
      box.setAttribute('data-ok', '1');
      var after = box.querySelector('[data-n-ba-after]'), handle = box.querySelector('[data-n-ba-handle]'), btn = handle && handle.querySelector('button');
      if (!after || !btn) return;
      var pos = 50, drag = false;
      function set(p) { pos = clamp(p, 0, 100); after.style.clipPath = 'inset(0 0 0 ' + pos + '%)'; handle.style.left = pos + '%'; btn.setAttribute('aria-valuenow', Math.round(pos)); }
      function at(e) { var r = box.getBoundingClientRect(); set(((e.clientX - r.left) / r.width) * 100); }
      btn.addEventListener('pointerdown', function (e) { e.preventDefault(); btn.setPointerCapture(e.pointerId); drag = true; });
      btn.addEventListener('pointermove', function (e) { if (drag) at(e); });
      ['pointerup', 'pointercancel'].forEach(function (ev) { btn.addEventListener(ev, function () { drag = false; }); });
      box.addEventListener('click', function (e) { if (e.target.closest('button')) return; at(e); });
      btn.addEventListener('keydown', function (e) { var m = { ArrowLeft: pos - 5, ArrowRight: pos + 5, Home: 0, End: 100 }; if (e.key in m) { e.preventDefault(); set(m[e.key]); } });
      set(50);
    });
  }

  function initTesti(root) {
    root.querySelectorAll('[data-n-testi]:not([data-ok])').forEach(function (sec) {
      sec.setAttribute('data-ok', '1');
      var track = sec.querySelector('[data-n-testi-track]'), paused = false;
      if (!track) return;
      function step(d) {
        var card = track.querySelector('[data-card]'); var w = card ? card.getBoundingClientRect().width + 20 : 420;
        if (d > 0 && track.scrollLeft + track.clientWidth >= track.scrollWidth - 8) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: d * w, behavior: 'smooth' });
      }
      var prev = sec.querySelector('[data-n-prev]'), next = sec.querySelector('[data-n-next]');
      prev && prev.addEventListener('click', function () { step(-1); });
      next && next.addEventListener('click', function () { step(1); });
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      track.addEventListener('pointerleave', function () { paused = false; });
      if (sec.dataset.autoplay === 'true' && !reduced) {
        var iv = setInterval(function () {
          if (!document.body.contains(track)) return clearInterval(iv);
          if (paused) return;
          var r = track.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
          step(1);
        }, 5200);
      }
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-n-faq]:not([data-ok])').forEach(function (sec) {
      sec.setAttribute('data-ok', '1');
      var items = sec.querySelectorAll('[data-n-faq-item]');
      function set(i, open) {
        var it = items[i], b = it.querySelector('button'), p = it.querySelector('[data-n-faq-panel]'), ic = it.querySelector('[data-n-faq-icon]');
        b.setAttribute('aria-expanded', open); p.style.gridTemplateRows = open ? '1fr' : '0fr'; ic.style.transform = open ? 'rotate(45deg)' : 'none';
      }
      items.forEach(function (it, i) {
        it.querySelector('button').addEventListener('click', function () {
          var open = this.getAttribute('aria-expanded') !== 'true';
          items.forEach(function (_, k) { set(k, false); }); if (open) set(i, true);
        });
      });
    });
  }

  function initCfg(root) {
    root.querySelectorAll('[data-n-cfg]:not([data-ok])').forEach(function (sec) {
      sec.setAttribute('data-ok', '1');
      var chips = sec.querySelectorAll('[data-n-chip]'), cards = sec.querySelectorAll('[data-n-rec]'), empty = sec.querySelector('[data-n-rec-empty]');
      var why = {}; try { why = JSON.parse(sec.querySelector('[data-n-why-json]').textContent || '{}'); } catch (e) {}
      function paint(c, on) { c.setAttribute('aria-pressed', on ? 'true' : 'false'); c.style.background = on ? 'var(--n-bg)' : 'transparent'; c.style.color = on ? 'var(--n-ink)' : 'var(--n-bg)'; c.style.borderColor = on ? 'var(--n-bg)' : '#5A524B'; }
      function show(key, text) {
        var found = false;
        cards.forEach(function (c) {
          var on = key && c.dataset.key === key; c.style.display = on ? 'grid' : 'none';
          if (on) { found = true; var w = c.querySelector('[data-n-rec-why]'); if (w) w.textContent = text; }
        });
        if (empty) empty.style.display = found ? 'none' : 'grid';
      }
      function update() {
        var sel = [].filter.call(chips, function (c) { return c.getAttribute('aria-pressed') === 'true'; });
        if (!sel.length) return show(null);
        if (sel.length === 1) return show('zone-' + sel[0].dataset.idx, why.single || '');
        var groups = sel.map(function (c) { return c.dataset.group; });
        var key = groups.indexOf('escote') > -1 ? 'completo' : groups.indexOf('cuello') > -1 ? 'rostro-cuello' : 'rostro';
        var card = sec.querySelector('[data-n-rec][data-key="' + key + '"]');
        var singles = sel.reduce(function (n, c) { return n + (+c.dataset.price || 0); }, 0);
        var price = card ? +card.dataset.price || 0 : 0;
        var txt = (why[key] || '') + (price && singles > price ? ' Ahorras ' + money(singles - price) + ' frente a comprarlas por separado.' : '');
        show(key, txt);
      }
      chips.forEach(function (c) {
        paint(c, c.getAttribute('aria-pressed') === 'true');
        c.addEventListener('click', function () { paint(c, c.getAttribute('aria-pressed') !== 'true'); update(); });
      });
      update();
    });
  }

  function init(root) { scan(root); initAreas(root); initBA(root); initTesti(root); initFaq(root); initCfg(root); tick(); }
  window.NocteLanding = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target; if (t && t.matches && t.matches('[data-n-tab]')) t.click();
  });
})();
